var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookDemoCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.84143C4 5.74939 4.07462 5.67477 4.16666 5.67477H19.8333C19.9254 5.67477 20 5.74939 20 5.84143V19.9081C20 20.0002 19.9254 20.0748 19.8333 20.0748H4.16666C4.07462 20.0748 4 20.0002 4 19.9081L4 5.84143ZM6.04901 7.72183C5.95697 7.72183 5.88235 7.79644 5.88235 7.88849V17.8611C5.88235 17.9531 5.95697 18.0277 6.04901 18.0277H17.951C18.043 18.0277 18.1176 17.9531 18.1176 17.8611V7.88849C18.1176 7.79644 18.043 7.72183 17.951 7.72183H6.04901Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3164 10.244L4.68783 10.244L4.68783 6.58683L19.3164 6.58683L19.3164 10.244Z",
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 3.93147L17.4375 8.5029L15.3042 8.5029L15.3042 3.93147L17.4375 3.93147Z",
    fill: "#1A1B1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80078 3.93147L8.80078 8.5029L6.66745 8.5029L6.66745 3.93147L8.80078 3.93147Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookDemoCallIcon);
export default __webpack_public_path__ + "static/media/book-demo-call-icon.7c995358706faa6a8618c41a31b82c23.svg";
export { ForwardRef as ReactComponent };